<template>
  <modal :show.sync="openModal">
    <h4 slot="header" class="title title-up">{{ $t('app.modules.orders.form.record') }}</h4>

    <el-table stripe style="width: 100%" :data="queriedData">
      <el-table-column
        :label="$t('app.modules.orders.headers.modification_date')"
        min-width="200"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.fechaModificacion }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('app.modules.orders.headers.action')"
        min-width="200"
        sortable
      >
        <template slot-scope="scope">
          {{ $t('app.modules.orders.status.'+scope.row.estadoPedidoEntity.value) }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('app.modules.orders.headers.user')"
        min-width="200"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.usuario.nombre }}
        </template>
      </el-table-column>
    </el-table>

  </modal>
</template>

<script>
import {getResponse} from "@/util/utilities";

export default {
  components: {},
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
  },
  data() {
    return {
      openModal: false,
      idPedido: 0,
      tableColumns: [
        {
          prop: "fechaModificacion",
          label: "app.modules.orders.headers.modification_date",
          minWidth: 200
        },
        {
          prop: "estadoPedidoEntity.value",
          label: "app.modules.orders.headers.action",
          minWidth: 200
        },
        {
          prop: "usuario.nombre",
          label: "app.modules.orders.headers.user",
          minWidth: 180,
          className: "is-center"
        }
      ],
      tableData: [],
      searchedData: []
    }
  },
  mounted() {
    EventBus.$on("historialPedido",  async (row) => {
      this.idPedido = row.idPedido;
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      await this.loadRecord();

      this.$swal.close();
      this.openModal = true;
    });
  },
  methods: {
    async loadRecord(){
      let data = new FormData();
      data.append('idPedido', this.idPedido);

      let request = await this.$http.post(route("Pedidos/historialPedido"), data);
      let response = getResponse(request);

      console.log(response);
      if(response != null){
        this.tableData = response.pedidos;
      }
    }
  }
}
</script>

<style scoped>

</style>
